import { CategoriaDTO } from '@framework/api-client';
import { useTranslation } from '@framework/i18n';
import { Tag, Tooltip } from 'antd';
import * as React from 'react';
import styled from 'styled-components';
import { InquiryItemDivider } from './InquiryItemDivider';

const StyledTagBold = styled(Tag)`
  &&& {
    font-weight: 600;
  }
`;

export interface IInquiryCategoryRenderProps {
  categories?: CategoriaDTO[] | null;
}

export function InquiryCategoryRender(props: IInquiryCategoryRenderProps) {
  const { categories } = props;
  const { t } = useTranslation();
  if (!categories || categories.length == 0) return null;

  return (
    <div>
      <div> {t('domanda.copertina.categorie', 'Categorie')}:</div>
      {categories?.map(category => (
        <Tooltip key={category.id} title={category.descrizione}>
          <StyledTagBold>{category.etichetta}</StyledTagBold>
        </Tooltip>
      ))}
      <InquiryItemDivider />
    </div>
  );
}
